import Component from "../abstracts/Component";
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";

export default class WishlistLogic extends Component {

  constructor() {
    super();
    this.liveRegion = new OnDemandLiveRegion({
      level: 'assertive',
      delay: 1000,
    });
  }

  get CLASSES() {
    return {
      addBtnClass: "js-add-to-wish",
      addedBtnClass: "js-added-wish",
      removeBtnClass: "js-remove-from-wish",
      listingClassRemove: "icon-wishlist-full",
      listingClassAdd: "icon-wishlist-empty",
    };
  }

  get SELECTORS() {
    return {
      wishlistIcon: "[data-wishlist-icon]"
    }
  }

  // as is: wl icon full/empty style logic here
  // should be: every wishlistAdd and wishlistRemove call/logic here

  bindEvents() {
    let ctx = this;
    // event on add to wish
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, ({event, payload}) => {
      let btn = payload.elem;
      const addedMessage = payload.msg;
      if (btn) {
        const icon = btn.querySelector(ctx.SELECTORS.wishlistIcon);

        // Updating the aria label attribute
        btn.ariaLabel = btn.dataset.removeMessage;

        // adding and removing classes
        btn.classList.remove(ctx.CLASSES.addBtnClass);
        btn.classList.add(ctx.CLASSES.addedBtnClass);
        btn.classList.add(ctx.CLASSES.removeBtnClass);
        // listing
        if (icon && icon.classList.contains(ctx.CLASSES.listingClassAdd)) {
          icon.classList.remove(ctx.CLASSES.listingClassAdd);
          icon.classList.add(ctx.CLASSES.listingClassRemove);
        }
      }
      if (addedMessage) {
        this.liveRegion.sayMessage(addedMessage);
      }
    });

    // event on remove from wish
    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, ({event, payload}) => {
      // btn
      let btn = payload.elem;
      const removedMessage = payload.msg;
      if (btn) {
        const icon = btn.querySelector(ctx.SELECTORS.wishlistIcon);

        // Updating the aria label on btn
        btn.ariaLabel = btn.dataset.addMessage;

        // update classes on btn
        // adding and removing classes
        btn.classList.remove(ctx.CLASSES.addedBtnClass);
        btn.classList.remove(ctx.CLASSES.removeBtnClass);
        btn.classList.add(ctx.CLASSES.addBtnClass);
        // listing
        if (icon && icon.classList.contains(ctx.CLASSES.listingClassRemove)) {
          icon.classList.remove(ctx.CLASSES.listingClassRemove);
          icon.classList.add(ctx.CLASSES.listingClassAdd);
        }
      }
      if (removedMessage) {
        this.liveRegion.sayMessage(removedMessage);
      }
    });

  }

  render() {
    this.bindEvents();
  }
}
